export default "__VITE_ASSET__Dx$tmBn___"